import React from 'react';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'gold' | 'lime' | 'outline';
  className?: string;
  /** Nombre del pack que se envía al Meta Pixel al hacer clic. */
  pixelContent?: string;
  pixelValue?: number;
};
export function CtaButton({
  children,
  href = '#precios',
  size = 'lg',
  variant = 'gold',
  className = '',
  pixelContent = 'MegaPack Seño Jardín',
  pixelValue
}: CtaButtonProps) {
  const sizes = {
    md: 'px-6 py-3 text-sm sm:text-base',
    lg: 'px-8 py-4 text-base sm:text-lg'
  };
  const variants = {
    gold: 'bg-gold-400 text-forest-900 border-gold-500/30 hover:bg-gold-200',
    lime: 'bg-lime-500 text-forest-900 border-lime-600/30 hover:bg-lime-400',
    outline: 'bg-transparent text-forest-800 border-forest-200 hover:bg-forest-50'
  };
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: pixelContent,
      currency: 'ARS',
      ...(pixelValue ? {
        value: pixelValue
      } : {})
    });
  };
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center gap-2 rounded-full border-2 font-display font-extrabold uppercase tracking-wide shadow-lift transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus-visible:ring-4 focus-visible:ring-lime-400/50 ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-48" data-mp="39xzje4xctyts">
      {children}
    </a>;
}